import { cn } from 'root/src/client/v2/common/helpers/cn';
import { buildAssetUrl, assetSize } from 'root/src/client/v2/common/helpers/assetUrl';
import { RedesignLink } from 'root/src/client/v2/common/components/ui/link';
import { rankAccent, creatorStat } from 'root/src/client/v2/_pages/creators-leaderboard/redesign/creatorsLeaderboard.helpers';
import { Img } from 'root/src/client/v2/common/components/ui/image';
// One leaderboard entry: rank (medal-coloured for the top three), avatar with a matching ring, name
// (+ a "You" chip for the signed-in creator), and the ranking stat. The whole row links to the
// creator's profile.
export const LeaderboardRow = ({ creator }) => {
    var _a, _b, _c, _d;
    const accent = rankAccent(creator.rankLabel);
    const stat = creatorStat(creator);
    const initial = (_d = (_c = (_b = (_a = creator.displayName) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.toUpperCase()) !== null && _d !== void 0 ? _d : '?';
    return (<RedesignLink href={creator.profileUrl} className={cn('flex items-center gap-4 rounded-xl border border-solid px-4 py-3 no-underline transition-colors', creator.isMe
            ? 'border-primary/40 bg-primary/[0.08]'
            : 'border-white/[0.06] bg-white/[0.02] hover:bg-white/[0.04]')}>
			<span className={cn('w-7 shrink-0 text-center text-lg font-bold tabular-nums', accent.textClass)}>{creator.rank}</span>

			<div className={cn('flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full ring-2', accent.ringClass)}>
				{creator.avatarUrl
            ? <Img src={buildAssetUrl(creator.avatarUrl, { w: assetSize('thumbnail'), q: 80, fmt: 'webp' })} alt="" className="h-full w-full object-cover"/>
            : <span className="flex h-full w-full items-center justify-center bg-gradient-brand text-sm font-semibold text-white">{initial}</span>}
			</div>

			<div className="min-w-0 flex-1">
				<div className="flex items-center gap-2">
					<p className="truncate text-sm font-medium text-foreground">{creator.displayName}</p>
					{creator.isMe && (<span className="shrink-0 rounded-full border border-solid border-primary/40 bg-primary/15 px-1.5 py-0.5 text-[10px] font-semibold text-foreground">You</span>)}
				</div>
				<p className="text-xs text-muted-foreground">{stat.label}</p>
			</div>

			<span className="shrink-0 text-sm font-semibold text-foreground">{stat.value}</span>
		</RedesignLink>);
};
